// extracted by mini-css-extract-plugin
export var scrollArea = "_oq-0";